module.exports = __webpack_public_path__ + "static/img/news2.f44f08f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news2.jpg
// module id = SgIN
// module chunks = 1